import { connect } from 'react-redux';
import CetakLaporanPersensi from '../../../../views/Student/report/cetak/CetakLaporanPersensi.student.view';
import { manageRegistration } from '../../../../states/thunks/student.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleManageRegistration: (payload, push) => dispatch(manageRegistration(payload, push)),
  };
}
export default connect(null, mapDispatchToProps)(CetakLaporanPersensi);
